'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _defaults = require('lodash/defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */

// SPA 切换路由多次初始化导致head标签里脚本与样式越来越多
function cleanUpScript() {
  var matches = document.querySelectorAll('head script, head link');

  if (matches && matches.length) {
    for (var i = 0; i < matches.length; i += 1) {
      var node = matches[i];
      if (/geetest\.com/i.test(node.nodeName.toLowerCase() === 'link' ? node.href : node.src)) {
        node.parentNode.removeChild(node);
      }
    }
  }
}

var RGCaptcha = function (_React$Component) {
  _inherits(RGCaptcha, _React$Component);

  function RGCaptcha(props) {
    _classCallCheck(this, RGCaptcha);

    var _this = _possibleConstructorReturn(this, (RGCaptcha.__proto__ || Object.getPrototypeOf(RGCaptcha)).call(this, props));

    _this.ins = null;
    _this.busy = false;
    _this.showed = false;
    _this.mounted = false;
    _this.hasChanged = false;
    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(RGCaptcha, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.load(false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.busy) {
        this.hasChanged = true;
        return;
      }
      this.load(true).finally(function () {
        if (_this2.hasChanged) {
          _this2.hasChanged = false;
          _this2.load(true);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var name = this.props.name;


      cleanUpScript();
      _storage2.default.remove(name);
      this.mounted = false;
    }
  }, {
    key: 'load',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(useCache) {
        var data, ignoreData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!(window && window.document) || this.busy || !this.mounted)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                this.busy = true;

                _context.next = 5;
                return this.loadData(useCache);

              case 5:
                data = _context.sent;
                ignoreData = useCache && (0, _isFunction2.default)(data);
                _context.next = 9;
                return this.loadIns(data, useCache, ignoreData);

              case 9:
                this.busy = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load(_x) {
        return _ref.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: 'loadData',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(useCache) {
        var data, fData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = this.props.data;
                fData = data;

                if (!((0, _isFunction2.default)(data) && !useCache)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return data().then(function (d) {
                  fData = d;
                }).catch(function () {
                  console.error('failed to fetch data'); // eslint-disable-line no-console
                });

              case 5:
                return _context2.abrupt('return', fData);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadData(_x2) {
        return _ref2.apply(this, arguments);
      }

      return loadData;
    }()
  }, {
    key: 'loadIns',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, useCache, ignoreData) {
        var _this3 = this;

        var _props, name, width, product, lang, protocol, area, nextWidth, bgColor, timeout, config;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props = this.props, name = _props.name, width = _props.width, product = _props.product, lang = _props.lang, protocol = _props.protocol, area = _props.area, nextWidth = _props.nextWidth, bgColor = _props.bgColor, timeout = _props.timeout;
                config = {
                  width: width,
                  product: product,
                  lang: lang,
                  protocol: protocol,
                  area: area,
                  next_width: nextWidth,
                  bg_color: bgColor,
                  timeout: timeout
                };
                _context3.next = 4;
                return _storage2.default.create(name, config, data, useCache, ignoreData).then(function (ins) {
                  if (ins !== _this3.ins) _this3.showed = false;
                  _this3.ins = ins;
                  _this3.bindEventFunc(_this3.props);
                  _this3.show();
                }).catch(function () {
                  console.error('failed to initialize'); // eslint-disable-line no-console
                }).finally(function () {
                  if (_this3.mounted) {
                    _this3.setState({
                      loading: false
                    });
                  }
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadIns(_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return loadIns;
    }()
  }, {
    key: 'bindEventFunc',
    value: function bindEventFunc(props) {
      var ins = this.ins;
      var onReady = props.onReady,
          onSuccess = props.onSuccess,
          onClose = props.onClose,
          onError = props.onError;

      if (ins && ins.hasBuildEventFunc) {
        ins.handleReady(onReady);
        ins.handleSuccess(function () {
          return onSuccess(ins.getValidate());
        });
        ins.handleClose(onClose);
        ins.handleError(onError);
      }
    }
  }, {
    key: 'show',
    value: function show() {
      var product = this.props.product;
      var ins = this.ins,
          box = this.box,
          showed = this.showed;

      if (ins && box && !showed && product !== 'bind') {
        while (box.firstChild) {
          box.removeChild(box.firstChild);
        }
        ins.appendTo(box);
        this.showed = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          product = _props2.product,
          loadingComponent = _props2.loadingComponent,
          loadingText = _props2.loadingText,
          _props2$style = _props2.style,
          style = _props2$style === undefined ? {} : _props2$style,
          className = _props2.className;
      var loading = this.state.loading;


      var LoadingTemp = void 0;

      if (loadingComponent) {
        LoadingTemp = _react2.default.createElement(loadingComponent, {
          loading: loading
        });
      } else {
        LoadingTemp = _react2.default.createElement(_Loading2.default, { loading: loading, text: loadingText });
      }

      var dStyle = (0, _defaults2.default)(style, {
        display: product === 'bind' ? 'none' : 'block',
        height: 44
      });

      return _react2.default.createElement(
        'div',
        { style: dStyle, className: className },
        LoadingTemp,
        _react2.default.createElement('div', {
          style: { display: loading ? 'none' : 'block' },
          ref: function ref(box) {
            _this4.box = box;
          }
        })
      );
    }
  }]);

  return RGCaptcha;
}(_react2.default.Component);

RGCaptcha.propTypes = {
  name: _propTypes2.default.string.isRequired,
  // 用于初始化的数据
  data: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    gt: _propTypes2.default.string.isRequired,
    challenge: _propTypes2.default.string.isRequired,
    success: _propTypes2.default.number.isRequired,
    new_captcha: _propTypes2.default.bool
  })]).isRequired,
  // 配置参数
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  product: _propTypes2.default.oneOf(['popup', 'float', 'custom', 'bind']),
  lang: _propTypes2.default.oneOf(['zh-cn', 'zh-hk', 'zh-tw', 'en', 'ja', 'ko', 'ru', 'ar', 'es', 'pt-pt', 'fr', 'de']),
  protocol: _propTypes2.default.oneOf(['http://', 'https://']),
  area: _propTypes2.default.string,
  nextWidth: _propTypes2.default.string,
  bgColor: _propTypes2.default.string,
  timeout: _propTypes2.default.number,
  // 事件
  onReady: _propTypes2.default.func,
  onSuccess: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  //
  loadingComponent: _propTypes2.default.func,
  loadingText: _propTypes2.default.string,
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  className: _propTypes2.default.string
};

RGCaptcha.defaultProps = {
  width: '300px',
  product: 'popup',
  lang: 'zh-cn',
  protocol: null,
  area: null,
  nextWidth: null,
  bgColor: null,
  timeout: null,
  onReady: null,
  onSuccess: null,
  onClose: null,
  onError: null,
  loadingComponent: null,
  loadingText: 'loading...',
  style: null,
  className: ''
};

exports.default = RGCaptcha;